if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.cartItems = document.querySelector('cart-items');
      this.quickshopPanel = document.querySelector('quick-shop-panel');

      // listen for event variant-change
      this.addEventListener('variant-change', this.onVariantChange.bind(this));
    }

    onVariantChange(evt) {
      const amount = evt.detail.variant.price;
      const paypalAmountElement = this.querySelector('[data-pp-amount]');

      if (paypalAmountElement && amount > 0) {
        // update the Paypal data-pp-amount attribute
        paypalAmountElement.setAttribute('data-pp-amount', (amount / 100).toFixed(2));
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      const productId = this.getAttribute('data-product-id');
      // the loop54Config is set in html-head-loop54.liquid and in the fetch-loop54-collections.ts, fetch-loop54-search.ts
      // and context/loop54/context.tsx
      /** @type {import('../react/src/context/loop54/types').Loop54Config['getLoop54Client']} */
      const loop54Client = window.loop54Config?.getLoop54Client?.();

      if (loop54Client && productId) {
        loop54Client.createEvent('addtocart', { type: 'Product', id: productId }, (response) => {
          if (response?.statusText !== 'OK' || response?.status >= 400) {
            console.error('Loop54 addtocart event failed');
          }
        });
      }

      const submitButton = this.querySelector('[type="submit"]');
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      if (this.quickshopPanel) {
        this.quickshopPanel.quickshopButtonLoading();
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const id = this.form.querySelector('[name="id"]').value;
      const sectionsToFetch = [...this.cartNotification.getSectionsToRender().map((section) => section.id)];

      const formData = new FormData(this.form);
      formData.append('sections', sectionsToFetch);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status == 422) {
            // When quantity error
            this.cartNotification.setActiveElement(document.activeElement);
            this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
            return;
          }

          // Refresh the items on the cart page
          if (this.cartItems) {
            this.cartItems.refreshState();
          }

          // Show the cart notification
          if (this.cartNotification) {
            this.cartNotification.setActiveElement(document.activeElement);

            // Use the product id from the form that was submitted
            this.cartNotification.renderContents({ ...parsedState, id, rootProductId: productId });
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');

          // Re-enable the quickshop button
          if (this.quickshopPanel) {
            this.quickshopPanel.disableQuickshopButton(false);
            this.quickshopPanel.quickshopButtonLoading(false);
          }
        });
    }
  }

  window.ProductForm = ProductForm;
  customElements.define('product-form', ProductForm);
}
